import React from "react";
import { Box, Typography } from "@mui/material";
import ProductionForecastChart from "./ProductionForecastChart";
import PastProductionForecastChart from "./PastProductionForecastChart";

interface ProductionForecastChartsProps {
  totalValues: any[];
  filters: any;
  xAxisLength?: number;
}

const ProductionForecastCharts = ({
  totalValues,
  filters,
  xAxisLength,
}): ProductionForecastChartsProps => {
  return (
    <Box
      sx={{
        m: 2,
        maxWidth: 500,
        position: "sticky",
        top: "1rem",
        right: "0",
        minWidth: 500,
      }}
    >
      <Typography component="p" fontSize={18} fontWeight={500}>
        Forecast chart
      </Typography>
      {totalValues ? (
        <ProductionForecastChart
          totalValues={totalValues}
          xAxisLength={xAxisLength}
        />
      ) : (
        <Typography component="p">Loading chart...</Typography>
      )}
      <PastProductionForecastChart filters={filters} />
    </Box>
  );
};

export default ProductionForecastCharts;
